<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Staff Register</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="card" id="register">
      <div class="card-body">
        <form class="text-center" @submit.prevent="registerStaff">
          <div class="row">
            <div class="col-md-6 form-group mb-3">
              <label for="">Full Name</label>
              <input
                type="text"
                class="form-control"
                v-model="name"
                placeholder="Enter Name"
              />
            </div>

            <div class="col-md-6 form-group mb-3">
              <label for="">Password</label>
              <input
                type="password"
                class="form-control"
                v-model="password"
                placeholder="Enter Password"
              />
            </div>

            <div class="col-md-6 form-group mb-3">
              <label for="">Email</label>
              <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="Enter Email"
              />
            </div>

            <div class="col-md-6 form-group mb-3">
              <label for="">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                v-model="password_confirmation"
                placeholder="Re-Enter Password"
              />
            </div>

            <div class="text-center">
              <input
                type="submit"
                class="btn btn-rounded text-white"
                style="background: #AC8400; width: 100px;"
                value="Register"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "register",

  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: ""
    };
  },

  methods: {
    registerStaff() {
      axios
        .post("/auth/register/staff", {
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(res => {
          alert("Successfully created user");
          this.name = "";
          this.email = "";
          this.password = "";
          this.password_confirmation = "";
        });
    }
  },

  mounted() {}
};
</script>
